"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _chatQuery = require("@/apollo/queries/chat-query");
var state = {
  room: {},
  rooms: [],
  roomUsers: [],
  messages: []
};
var mutations = {
  UPDATE_CHAT_ROOM: function UPDATE_CHAT_ROOM(state, room) {
    state.room = room.map(function (chat_room) {
      return chat_room;
    });
  },
  UPDATE_CHAT_ROOMS: function UPDATE_CHAT_ROOMS(state, rooms) {
    state.rooms = rooms.map(function (rooms) {
      return rooms;
    });
  },
  UPDATE_CHAT_ROOM_USERS: function UPDATE_CHAT_ROOM_USERS(state, users) {
    state.roomUsers = users.filter(function (room) {
      if (room.messages.length > 0) {
        return room;
      }
    });
  },
  UPDATE_CHAT_MESSAGE: function UPDATE_CHAT_MESSAGE(state, room) {
    state.messages = room.map(function (msgs) {
      return msgs;
    });
  }
};
var actions = {
  fetchChatRoom: function () {
    var _fetchChatRoom = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, roomId) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _chatQuery.CHAT_ROOM_QUERY,
              variables: {
                roomId: roomId
              }
            });
          case 1:
            res = _context.sent;
            commit('UPDATE_CHAT_ROOM', res.data.chat_room);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetchChatRoom(_x, _x2) {
      return _fetchChatRoom.apply(this, arguments);
    }
    return fetchChatRoom;
  }(),
  fetchChatRooms: function () {
    var _fetchChatRooms = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 1;
            return _apolloClient.apolloClient.query({
              query: _chatQuery.CHAT_ROOM_LIST_QUERY
            });
          case 1:
            res = _context2.sent;
            commit('UPDATE_CHAT_ROOMS', res.data.chat_room_category);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function fetchChatRooms(_x3) {
      return _fetchChatRooms.apply(this, arguments);
    }
    return fetchChatRooms;
  }(),
  fetchChatRoomUsers: function () {
    var _fetchChatRoomUsers = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.next = 1;
            return _apolloClient.apolloClient.query({
              query: _chatQuery.CHAT_ROOM_USER_LIST_QUERY,
              variables: {
                categoryId: data.categoryId,
                subCategoryId: data.subCategoryId,
                adminId: data.adminId
              },
              fetchPolicy: 'no-cache'
            });
          case 1:
            res = _context3.sent;
            commit('UPDATE_CHAT_ROOM_USERS', res.data.chat_room);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function fetchChatRoomUsers(_x4, _x5) {
      return _fetchChatRoomUsers.apply(this, arguments);
    }
    return fetchChatRoomUsers;
  }(),
  fetchChatMessages: function () {
    var _fetchChatMessages = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, roomId) {
      var commit;
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            _apolloClient.apolloClient.watchQuery({
              query: _chatQuery.CHAT_MESSAGES_QUERY,
              variables: {
                roomId: roomId
              },
              fetchPolicy: 'no-cache',
              pollInterval: 3000 // ms
            }).subscribe(function (data) {
              commit('UPDATE_CHAT_MESSAGE', data.data.messages);
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function fetchChatMessages(_x6, _x7) {
      return _fetchChatMessages.apply(this, arguments);
    }
    return fetchChatMessages;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};